export default{
    clientes: [],
    clienteSelec: null,
}